import React, { Component, ReactNode } from "react";
import { Scrollbars } from "react-custom-scrollbars-2";

// Define the props interface
interface ColouredScrollbarsProps {
  theme?: string; // Assuming theme is a string ("dark" or "light")
  children?: ReactNode; // Add children to props
}

interface ColouredScrollbarsState {
  top: number;
}

export default class ColouredScrollbars extends Component<
  ColouredScrollbarsProps,
  ColouredScrollbarsState
> {
  constructor(props: ColouredScrollbarsProps) {
    super(props);
    this.state = { top: 0 };
    this.handleUpdate = this.handleUpdate.bind(this);
    this.renderThumb = this.renderThumb.bind(this);
  }

  handleUpdate(values: { top: number }) {
    const { top } = values;
    this.setState({ top });
  }

  renderThumb({ style, ...props }: { style?: React.CSSProperties }) {
    const { theme } = this.props;

    const thumbStyle: React.CSSProperties = {
      backgroundColor: theme == "dark" ? "#808080" : "#999999", // Use theme color based on condition
      borderRadius: "100px", // Rounds all four corners of the scrollbar thumb
    };

    return <div style={{ ...style, ...thumbStyle }} {...props} />;
  }

  render() {
    return (
      <Scrollbars
        renderThumbHorizontal={this.renderThumb}
        renderThumbVertical={this.renderThumb}
        onUpdate={this.handleUpdate}
        {...this.props}
      />
    );
  }
}
